import lottie from 'lottie-web';
import { preloadImages } from '@data/preload-assets';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'LoadScene',
    });
  }

  async preload() {
    this.load.image('overlay', 'assets/GameAssets/overlay.png');
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');

    await loadFonts();
  }

  create() {
    this.screenOverlay = this.add.image(0, 0, 'overlay').setOrigin(0);

    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    preloadImages(this);
    this.assetsLoad();
    this.audioLoad();

    this.load.start();

    this.load.on(
      'progress',
      function () {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      function () {
        console.info('complete');
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;

    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    // Confetti and tick atlases (frame-based animations from demo)
    this.load.atlas(
      'confetti',
      'assets/GameScene/confettiAnim.png',
      'assets/GameScene/confettiAnim.json',
    );
    this.load.atlas(
      'tick',
      'assets/GameScene/tickAnim.png',
      'assets/GameScene/tickAnim.json',
    );

    // Character multiatlas (StartScene running character)
    this.load.multiatlas(
      'character',
      'assets/StartScene/G5 Game Character Anim/characterTopAnim.json',
      'assets/StartScene/G5 Game Character Anim',
    );
  }

  audioLoad() {
    // Demo audio lives under assets/GameAssets/audio (copied from "G5 Practice Game Sounds")
    const base = 'assets/GameAssets/audio';
    this.load.audio('bgMusic', `${base}/BGMusic.mp3`);
    this.load.audio('candiesAppear', `${base}/candiesAppear.mp3`);
    this.load.audio('candiesGrouping', `${base}/candies grouping.mp3`);
    this.load.audio('bowlAppear', `${base}/bowl appear.mp3`);
    this.load.audio('correctAnswers', `${base}/correctAnswer.mp3`);
    this.load.audio('incorrectAnswers', `${base}/incorrectAnswer.mp3`);
  }
}
